// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2xiFc","insightsList":"newBusinessInsightsMenu_insightsList__2QN87","active":"newBusinessInsightsMenu_active__B63zr"};